export enum TriggerActivityType {
  ContactEntersSegment = 'segments-contact_enters_segment',
  SocialMediaChannelFollowed = 'wix_loyalty-social_media_channel_followed',
}
